import operations from '~/helpers/device-operations';
import { Operation } from '~/interfaces/device.interface';
import { FieldObject } from '~/interfaces/field.interface';
import apiService from '~/services/api.service';
import { DevicesModule } from '~/store/modules/devices';
import { LegrandGateway } from './LegrandGateway.model';

export class NLEVSE extends LegrandGateway {
    hasModulesCount = false;
    MAX_TIME_BEFORE_UNKNOWN = 6 * 3600;
    shouldFetchSyncData = true;
    power_board_firmware_revision: string = '';
    nom_current: string | number = '';
    num_poles: string | number = '';
    overload_protections: string | boolean = ''
    temperature_protection: string | boolean = ''
    rcd: string | boolean = ''
    pe_continuity: string | boolean = ''
    dom_socket: string | boolean = ''
    motor_contact: string | number = ''
    power_limit: string = ''
    nlevse_nlpd_association?: string
    rs485_link_state?: boolean
    tic_link_state?: boolean

    get deviceOperations(): Operation[]  {
        return super.deviceOperations.concat([
            operations.modelDump({ callback: this.modelDump }),
            operations.dump({ callback: this.dump }),
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.diagnosis({ callback: this.getDiagnosis }),
            operations.switchDatabase({
                callback: this.switchDatabase,
                disabled: this.isSwitchDatabaseDisabled,
            }),
        ]);
    }

    getNetworkFields() {
        let fields = super.getNetworkFields();
        fields = fields.filter((field) => field.key !== 'Connection');
        fields.push({
            key: 'Connection',
            value: this.network?.connection,
        });
        return fields;
    }

    async loadSyncData() {
        const configs = (await apiService.getConfigs({ device_id: this.id })).data?.body?.home?.modules?.[0] as any;
        if (configs) {
            DevicesModule.addDeviceInfo({
                deviceId: this.id,
                additionalInfo: {
                    power_board_firmware_revision: configs.power_board_firmware_revision,
                    nom_current: configs.nom_current,
                    num_poles: configs.num_poles,
                    overload_protections: configs.overload_protections,
                    temperature_protection: configs.temperature_protection,
                    rcd: configs.rcd,
                    pe_continuity: configs.pe_continuity,
                    dom_socket: configs.dom_socket,
                    motor_contact: configs.motor_contact,
                    power_limit: configs.power_limit,
                }
            });
        }
    }

    get settingsFields(): FieldObject[] {
        return [
            { key: 'Rotary Switch', value: this.power_limit },
            { key: 'TIC detected', value: this.tic_link_state },
            { key: 'RS485', value: this.rs485_link_state },
            { key: 'NLPD linked', value: this.nlevse_nlpd_association },
        ];
    }

    get powerBoardFields(): FieldObject[] {
        return [
            { key: 'Power board firmware', value: this.power_board_firmware_revision },
            { key: 'Nominal current', value: this.nom_current },
            { key: 'Number of poles', value: this.num_poles },
            { key: 'Overload protections', value: this.overload_protections },
            { key: 'Temperature protection', value: this.temperature_protection },
            { key: 'RCD', value: this.rcd },
            { key: 'Ground continuity', value: this.pe_continuity },
            { key: 'Dom socket', value: this.dom_socket },
            { key: 'Motor contact', value: this.motor_contact },
        ];
    }
}
